module.exports = "/_next/static/images/b3c3e81da50ab0ff413ec732ca80f7dd-nubanker-eng@2x.jpg.webp";